import initialState from './initialState';
import { types } from '../actions/budgetActions';
import applicationStatuses from '../components/budget/applicationStatuses';

export default function budgetApplicationsReducer(state = initialState.budgetApplications, action) {
  switch (action.type) {
    case types.GET_MY_APPLICATIONS_SUCCESS: {
      const { applications } = action;
      
      applications.forEach(element => element.application.statusDescription = applicationStatuses[element.application.status].name);

      return {
        fetching: false,
        data: Object.assign(applications, state.data),
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/budgetApplicationsReducer.js